export const MusicData =[
    {
        
        id:'1',
        imageUrl: 'user.png',
        songName: 'So For So Good',
        artistName: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67706f000000028dcbced526ef8247c358fd0a',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '1',
        albumId: '1',
        
    },
    {
        id:'2',
        imageUrl: 'user.png',
        songName: 'Apricity',
        artistName: 'Hendrix Stamp',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67616d00001e0212b7442d3b3eea9a482bcdcd',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '2',
        albumId: '1',
        
    },
    {
        id:'3',
        imageUrl: 'user.png',
        songName: 'Solatium',
        artistName: 'Stephen Grider',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67616d00001e02a85ed299de5c1183c3e94a01',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '3',
        albumId: '1',
        
    },
    {
        id:'4',
        imageUrl: 'user.png',
        songName: 'Efflorescence',
        artistName: 'Mohannad Zitoun',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67616d00001e0289a4c0d212dc71f9ae386217',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '4',
        albumId: '1',
        
    },
    {
        id:'5',
        imageUrl: 'user.png',
        songName: 'Gather My Thoughts',
        artistName: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67706f00000002b5d03b4eccf9aa6b902d0666',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '1',
        albumId: '1',
        
    },
    {
        id:'6',
        imageUrl: 'user.png',
        songName: 'Fresh Paint',
        artistName: 'Surfiya Zakir',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67706f00000002636626b48ba21c6b0d92aa1d',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '6',
        albumId: '1',
        
    },
    {
        id:'7',
        imageUrl: 'user.png',
        songName: 'Infinite Sustain',
        artistName: 'Aliqa Macale',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67706f0000000203886962382b0ccf093feda6',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '1',
        albumId: '1',
        
    },
    {
        id:'8',
        imageUrl: 'user.png',
        songName: 'Borealis',
        artistName: 'Hendrix Stamp',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67616d00001e0212b7442d3b3eea9a482bcdcd',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '2',
        albumId: '1',
        
    },
    {
        id:'9',
        imageUrl: 'user.png',
        songName: 'Once I Dreamed',
        artistName: 'Stephen Grider',
        email: 'support@gmail.com',
        bgImage: 'https://i.scdn.co/image/ab67616d00001e02a85ed299de5c1183c3e94a01',
        description: 'This is how we do it, This is our style. Cover: Sidhu...',
        likes: 55,
        views: '823,132,1',
        albumName:'rival',
        artistId: '3',
        albumId: '1',
        
    },
]